import { DashboardApi20240730 } from '@sequencehq/api/dashboard/v20240730'

type BillingSchedulePhase =
  DashboardApi20240730.GetBillingSchedule.BillingSchedulePhase

/**
 * For saving a schedule we've just read back to the API. Phases come back with
 * their contract references, but a request that sends them replaces every
 * reference on the schedule, and is refused when a phase also carries the
 * legacy `externalContractRef`. Dropping them leaves the references as they
 * are.
 */
export const withoutContractReferences = <
  Schedule extends { phases: Array<BillingSchedulePhase> }
>(
  schedule: Schedule
): Omit<Schedule, 'phases'> & {
  phases: Array<Omit<BillingSchedulePhase, 'contractReferences'>>
} => ({
  ...schedule,
  phases: schedule.phases.map(
    ({ contractReferences: _contractReferences, ...phase }) => phase
  )
})
